// Token styling classes for source code rendering.
// Each token is assigned an ETokenStyleClass by the backend

// Default token styles
.KEYWORD {
	color: #131387;
	font-weight: bold;
}
.LITERAL {
	color: #a31515;
}
.IDENTIFIER {
	color: #000000;
}
.OPERATOR {
	color: #000000;
}
.DELIMITER {
	color: #000000;
}
.COMMENT {
	color: #3f7f5f;
}
.DOC_COMMENT {
	color: #3f5fbf;
}
.ANNOTATION {
	color: #808003;
}
.SPECIAL {
	color: #000000;
}
.ERROR {
	color: #ff0000;
	font-weight: bold;
}
.SYNTHETIC {
	color: #ff0000;
	font-weight: bold;
}
.PLAIN_TEXT {
	color: #000000;
}
.FILTERED {
	color: #c0c0c0;
}
.COMMENT_LINK {
	color: #3f7f5f;
	font-weight: bold;
}
.BROKEN_COMMENT_LINK {
	color: #ff0000;
	font-weight: bold;
}
.ISSUE_REFERENCE {
	color: #3f7f5f;
	font-weight: bold;
}
.SEARCH_HIGHLIGHT {
	color: #000000;
	background: lightyellow;
}

// Language-specific overrides via data-language on ancestor elements
:global([data-language='CS']),
:global([data-language='VB']) {
	.DOC_COMMENT {
		color: #808080;
	}
	.SPECIAL {
		color: #c8c8c8;
	}
}

:global([data-language='PLSQL']) {
	.OPERATOR {
		color: #131387;
		font-weight: bold;
	}
}
